export const maybeEmptyInfo = <T,>(
  value: T,
  renderFn?: (value: NonNullable<T>) => React.ReactNode,
) => (value ? (renderFn?.(value) ?? String(value)) : '–');

export const getEstimatedTextWidth = (text: string) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) return 0;

  context.font = '12px sans-serif';
  return Math.round(context.measureText(text).width);
};
